export const cardData = [
  {
    id: 'cost-monitoring',
    title: 'Cost Monitoring',
    description: [
      'LLM Insight allows you to track your LLM expenses in real-time, offering visibility into the costs of each API call.',
      "You can monitor spending by model, department, or project to ensure you're staying within budget.",
      'The platform allows for setting custom cost limits, so you’re alerted if expenses exceed thresholds.',
      'This feature helps businesses prevent unexpected overages and optimize their AI investments.',
    ],
    additionalInfo: [
      'Cost monitoring is a critical feature for businesses using AI models, as it provides detailed insights into the cost of every API call.',
      'By monitoring costs at the model, department, or project level, organizations can allocate resources more efficiently.',
      'Customizable cost limits can be set, ensuring that businesses stay within budget.',
      'Real-time alerts notify stakeholders if costs approach predefined limits, preventing unexpected expenses.',
      'The transparency in costs allows businesses to make informed decisions, helping to maximize ROI.',
      'The feature integrates seamlessly with various AI tools, enabling businesses to control expenses while scaling AI usage.',
      'Cost monitoring empowers decision-makers by providing data-driven insights into spending patterns, which can help identify areas for improvement.',
      'With this tool, businesses can easily track costs, optimize their workflows, and improve overall efficiency.',
      'It is a must-have for any organization looking to keep their AI spending under control.',
      'Additionally, businesses can forecast future spending based on usage patterns and set alerts accordingly.',
    ],
    src: 'cost_monitoring.png',
    url: '/cost-monitoring',
    color: '#CDEAFF',
  },
  {
    id: 'chat-window',
    title: 'Single Chat Window',
    description: [
      'Unified chat window in LLM Insight for interacting with multiple LLM providers and models through a single interface.',
      'Streamlines workflows by eliminating the need to switch between different platforms.',
      'Supports popular models such as OpenAI, Anthropic, and Gemini for easy comparisons and seamless integration.',
      'Improves productivity by consolidating all AI interactions in one place.',
      'Allows for quick interactions, improving response times and overall efficiency.',
      'Ideal for teams needing to interact with multiple LLM providers without switching tools.',
      'Facilitates seamless model comparisons to help businesses choose the best-performing AI solutions.',
    ],
    additionalInfo: [
      'Consolidates interactions with multiple LLM providers into one platform, saving time and enhancing productivity.',
      'Easily compare and choose the best AI models based on specific needs.',
      'Eliminates friction by providing a unified interface for various AI tools.',
      'Supports seamless transitions between different AI providers, making interactions quicker and more efficient.',
      'Improves collaboration and streamlines AI workflows for teams working with diverse models.',
      'User-friendly interface that simplifies AI interactions for non-technical users.',
      'Essential tool for businesses looking for flexibility and efficiency in AI-driven operations.',
    ],
    src: 'single_chat_window.png',
    url: '/chat-window',
    color: '#FFD6CD',
  },
  {
    id: 'logs',
    title: 'Logs',
    description: [
      'LLM Insight collects detailed logs of all API calls to ensure full transparency in your AI operations.',
      'Logs include metadata such as response times, status codes, and error messages, making it easy to monitor performance.',
      'You can audit historical data, track usage patterns, and ensure compliance with regulations.',
      'The system is designed to offer full traceability for security and troubleshooting purposes.',
    ],
    additionalInfo: [
      'The logs feature in LLM Insight provides full transparency into all AI operations, ensuring businesses can monitor and audit every API call.',
      'Detailed logs include metadata such as response times, status codes, and error messages, making it easier to diagnose issues.',
      'This feature enables businesses to trace anomalies, track usage over time, and ensure compliance with industry regulations.',
      'Historical data can be audited for transparency and accountability, allowing for more efficient monitoring.',
      'The traceability of logs is crucial for security, enabling administrators to detect and address unauthorized access or issues promptly.',
      'Logs help track performance and identify bottlenecks or underperforming models.',
      'Businesses can use this feature to improve AI workflows, optimize models, and reduce downtime.',
      'With detailed logs, organizations gain actionable insights to enhance model performance and ensure compliance.',
      'The logs feature assists in troubleshooting, offering a comprehensive view of each API call, which is invaluable for optimizing AI processes.',
    ],
    src: 'logs.png',
    url: '/logs',
    color: '#CDCFFF',
  },
  {
    id: 'containerization',
    title: 'Containerization',
    description: [
      'Containerization in LLM Insight means each LLM model is deployed as a microservice, offering flexibility and scalability.',
      'This modular approach allows for easy scaling of individual models based on workload requirements.',
      'Containerized services can be independently updated or replaced without affecting the entire system.',
      'It enables high availability and efficiency, as each container can be optimized for its specific task or model.',
    ],
    additionalInfo: [
      'Containerization is a key feature in LLM Insight that enhances the flexibility and scalability of AI models.',
      'By deploying each LLM model as a microservice, businesses can scale individual models based on specific workload requirements.',
      'This modular approach ensures that updates or replacements can be done independently, without impacting other parts of the system.',
      'Containerized services help achieve high availability by optimizing each model for its task.',
      'It simplifies management, as containers can be deployed across multiple environments and cloud providers.',
      'With containerization, businesses can ensure that each AI model runs at peak efficiency and is updated independently.',
      'This feature is ideal for large-scale deployments where flexibility and performance are critical.',
      'Containerization facilitates smoother integration with other services, making it easier to connect to various systems.',
      'Overall, containerization enhances scalability, reliability, and performance, making it an essential feature for deploying AI solutions at scale.',
    ],
    src: 'containerization.png',
    url: '/containerization',
    color: '#E1FFCD',
  },
  {
    id: 'chargeback-invoicing',
    title: 'Chargeback and Invoicing',
    description: [
      'The chargeback and invoicing system in LLM Insight enables businesses to allocate AI costs to specific projects, teams, or departments.',
      'It provides detailed reporting on AI usage, helping organizations maintain accurate financial records.',
      'The platform supports generating invoices based on usage, ensuring that each team pays for its exact share of the costs.',
      'This helps ensure transparency in cost-sharing among different stakeholders within an organization.',
    ],
    additionalInfo: [
      'Chargeback and invoicing in LLM Insight provides businesses with the tools to allocate AI costs across projects, teams, or departments.',
      'This enables organizations to track AI usage and generate detailed reports, ensuring accurate financial records.',
      'The system allows for automatic generation of invoices based on actual usage, ensuring fair cost distribution among departments or teams.',
      'This transparency is vital for organizations with multiple stakeholders, ensuring each department is accountable for its usage.',
      'Businesses can identify cost drivers and optimize resource allocation to prevent overspending.',
      'The invoicing system is highly customizable, allowing businesses to reflect their internal cost structures.',
      'It simplifies budgeting by providing clear, actionable data on AI usage.',
      'Chargeback and invoicing helps businesses comply with financial regulations by offering accurate and detailed billing records.',
      'Overall, this system supports better financial planning and cost management, ensuring that AI usage is cost-effective and transparent.',
    ],
    src: 'pro_chargback.png',
    url: '/chargeback-invoicing',
    color: '#FFD6CD',
  },
  {
    id: 'llm-compare',
    title: "LLM Insight's Edge Over Other AI Platforms",
    description: [
      'LLM Insight Offers a unified single chat interface for all models, supporting attachments like PDFs, images, and CSVs for seamless interaction. Other platforms lack this feature, requiring separate interactions for each model without attachment support.',
      'LLM Insight Uses containerization for flexible, scalable deployment with a single entry point for all LLM models',
      'LLM Insight Provides a single dashboard that integrates model data, costing, logs, and chargebacks in one view. Other platforms do not offer a unified dashboard, requiring separate tools for different aspects of model management.',
    ],
    additionalInfo: [
      'LLM Insight Integrates with Azure Active Directory for enhanced accountability and compliance management.',
      'Provides granular cost monitoring across model, provider, project, and department levels.',
      'Sends real-time alerts for model costs, invoices, and chargebacks to take immediate action on financial issues.',
      'Tracks costs modelwise, providerwise, projectwise, and departmentwise, providing detailed financial oversight.',
      'Integrates seamlessly with AWS, GCP, and Azure, providing deployment flexibility across cloud environments.',
      'It leverages containerization, allowing flexible and scalable deployment, unlike other platforms that lack such modularity.',
      'Additionally, it provides a single dashboard to monitor model data, costing, and logs, consolidating all crucial information.',
      'LLM Insight integrates with Azure Active Directory for enhanced security and compliance, while also offering granular cost monitoring across multiple levels.',
      'It supports real-time alerts for cost and billing, making financial tracking easier. Furthermore, LLM Insight enables deployment across AWS, GCP, and Azure, offering true multi-cloud flexibility, whereas other platforms are more limited in this regard.',
    ],
    src: 'llm_compare.jpg',
    url: '/llm-compare',
    color: '#eacdff',
  },
];

export const clients = [
  {
    id: 1,
    name: 'Trika Technologies',
    tagline: 'AI-driven solutions for modern enterprises.',
    logo: 'trika.png', // Replace with actual path
  },
  {
    id: 2,
    name: 'Elemrex',
    tagline: 'Pioneering AI-driven innovations.',
    logo: 'elemrex.png', // Replace with actual path
  },
  {
    id: 3,
    name: 'ConceptVines',
    tagline: 'Transforming business strategies with AI insights.',
    logo: 'cv.png', // Replace with actual path
  },
  {
    id: 4,
    name: 'Mott MacDonald',
    tagline: 'Engineering, management and development consultancy',
    logo: 'mm.png', // Replace with actual path
  },
  {
    id: 5,
    name: 'Intelagen',
    tagline: 'Leaders in AI and Web3 Innovation',
    logo: 'intelagen.png', // Replace with actual path
  },
  {
    id: 6,
    name: 'Scholars',
    tagline: 'Learn Better. Excel Smarter. With AI',
    logo: 'scholars.png', // Replace with actual path
  },
  {
    id: 6,
    name: 'XpatPAL',
    tagline: 'Transforming the way people travel',
    logo: 'xpatpal.png', // Replace with actual path
  },
];

export const videoList = [
  {
    id: 1,
    name: 'LLM Insight Ad',
    url: 'sst_ad.mp4',
    thumbnail: 'thumbnail1.png',
    type: 'local',
  },
  {
    id: 2,
    name: 'YouTube: LLM Insight Demo',
    url: 'https://www.youtube.com/embed/dJTMUpHqXLo',
    thumbnail: 'https://img.youtube.com/vi/dJTMUpHqXLo/hqdefault.jpg',
    type: 'youtube',
  },
  {
    id: 3,
    name: 'LLM Insight Overview',
    url: 'LLM_Insight_intro.mp4',
    thumbnail: 'thumbnail2.jpg',
    type: 'local',
  },
  {
    id: 4,
    name: 'LLM Insight Introduction',
    url: 'LLM Insight short introduction.mp4',
    thumbnail: 'thumbnail3.jpg',
    type: 'local',
  },
  {
    id: 5,
    name: 'SST AI Framework',
    url: 'Video 1 Introduction to SSTAI Framework.mp4',
    thumbnail: 'thumbnail4.png',
    type: 'local',
  },
  {
    id: 6,
    name: 'YouTube Demo',
    url: 'https://www.youtube.com/embed/7Um76Nved4M', // Convert to embed URL
    thumbnail: 'https://img.youtube.com/vi/7Um76Nved4M/0.jpg', // You'll need a thumbnail image
    type: 'youtube',
  },
  {
    id: 7,
    name: 'YouTube Demo',
    url: 'https://www.youtube.com/embed/iORGoFlhl8Y', // Convert to embed URL
    thumbnail: 'https://img.youtube.com/vi/iORGoFlhl8Y/hqdefault.jpg', // You'll need a thumbnail image
    type: 'youtube',
  },
  {
    id: 8,
    name: 'YouTube Demo',
    url: 'https://www.youtube.com/embed/Hx5Jowbdt8M', // Convert to embed URL
    thumbnail: 'https://img.youtube.com/vi/Hx5Jowbdt8M/hqdefault.jpg', // You'll need a thumbnail image
    type: 'youtube',
  },
  {
    id: 9,
    name: 'YouTube Demo',
    url: 'https://www.youtube.com/embed/7w_Jr8w_zH8', // Convert to embed URL
    thumbnail: 'https://img.youtube.com/vi/7w_Jr8w_zH8/hqdefault.jpg', // You'll need a thumbnail image
    type: 'youtube',
  },
  {
    id: 10,
    name: 'YouTube Demo',
    url: 'https://www.youtube.com/embed/5SeQ6yPdn3M', // Convert to embed URL
    thumbnail: 'https://img.youtube.com/vi/5SeQ6yPdn3M/hqdefault.jpg', // You'll need a thumbnail image
    type: 'youtube',
  },
  {
    id: 11,
    name: 'YouTube Demo',
    url: 'https://www.youtube.com/embed/fC6Qdom7BBQ', // Convert to embed URL
    thumbnail: 'https://img.youtube.com/vi/fC6Qdom7BBQ/hqdefault.jpg', // You'll need a thumbnail image
    type: 'youtube',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: 'Slide 1',
    description: 'This is the first slide',
    url: 'carousel1.png',
  },
  {
    id: 2,
    title: 'Slide 2',
    description: 'This is the second slide',
    url: 'carousel2.jpg',
  },
  {
    id: 3,
    title: 'Slide 3',
    description: 'This is the third slide',
    url: 'carousel3.jpg',
  },
  {
    id: 4,
    title: 'Slide 4',
    description: 'This is the fourth slide',
    url: 'carousel4.jpg',
  },
  {
    id: 5,
    title: 'Slide 5',
    description: 'This is the fifth slide',
    url: 'carousel5.png',
  },
  {
    id: 6,
    title: 'Slide 6',
    description: 'This is the sixth slide',
    url: 'carousel6.jpg',
  },
];

export const benefitsList = [
  {
    title: 'Governance & Control',
    description: 'You can manage all LLMs under a single window with the SSTAI Framework.',
  },
  {
    title: 'Cost Monitoring/Spend Control',
    description: 'Prevents unnecessary expenses with real-time tracking.',
  },
  {
    title: 'Usage Insights',
    description: 'Tracks LLM usage across departments and projects.',
  },
  {
    title: 'Single Interface for All LLMs',
    description: 'Eliminates the complexity of managing multiple chat models.',
  },
  {
    title: 'Security & Permissions',
    description: 'Integrates with Active Directory for controlled access.',
  },
  {
    title: 'Containerization for Scalability',
    description: 'Deploys LLM APIs in a containerized format for seamless expansion.',
  },
  {
    title: 'Automated Alerts',
    description: 'Automatically notifies users when predefined limits are reached, ensuring timely actions.',
  },
  {
    title: 'Automated Invoices',
    description: 'Generates invoices automatically for specified periods, streamlining billing processes.',
  },
  {
    title: 'Customized Chargeback',
    description: 'We can set a chargeback to the project or department in the organization.',
  },
];

export const providers = [
  {
    name: 'OpenAI',
    logoUrl: '/providers/openai.png',
    models: [
      'gpt-4o',
      'gpt-4o-2024-11-20',
      'gpt-4o-2024-08-06',
      'gpt-4o-mini',
      'o1',
      'gpt-4o-mini-2024-07-18',
      'o1-mini',
      'text-embedding-3-small',
      'text-embedding-3-large',
      'gpt-3.5-turbo',
      'text-embedding-3-small',
      'text-embedding-3-large',
      'gpt-3.5-turbo',
    ],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Google Vertex AI',
    logoUrl: '/providers/vertex.png',
    models: [
      'gemini-1.5-pro-002',
      'gemini-2.0-flash',
      'gemini-2.0-flash-lite',
      'gemini-1.0-pro',
    ],
    unimplemented: [
      'claude-3-7-sonnet@20250219',
      'claude-3-opus@20240229',
      'gemini-2.5-pro-preview-03-25',
      'text-bison@002',
      'mistral-small-2503@001',
      'gemma-3-1b-it',
      'llama3',
      'llama2',
    ],
    thirdParty: ['claude-3-5-haiku@20241022'],
  },
  {
    name: 'AI21',
    logoUrl: '/providers/ai21.jpg',
    models: [
      'jamba-1.5-large',
      'jamba-instruct-preview',
      'jamba-1.5-mini',
      'jamba-instruct',
    ],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Cohere',
    logoUrl: '/providers/cohere.png',
    models: [
      'command-r-plus-08-2024',
      'c4ai-aya-exapnse-8b',
      'command-r7b-12-2024',
      'command-r',
      'command-light',
    ],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Ollama',
    logoUrl: '/providers/ollama.png',
    models: ['llama2:latest', 'llama3:latest', 'llava:latest'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Mistral',
    logoUrl: '/providers/mistral_ai.png',
    models: ['dolphin-mixtral:latest', 'mistral-large:latest'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Anthropic',
    logoUrl: '/providers/anthropic.png',
    models: ['claude-v1'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'DeepSeek',
    logoUrl: '/providers/deepseek.png',
    models: ['deepseek-r1:70b', 'deepseek-r1:latest'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Google',
    logoUrl: '/providers/gemini.png',
    models: ['gemini-pro'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Minimax',
    logoUrl: '/providers/minimax.png',
    models: ['MiniMax-Text-01'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Upstage',
    logoUrl: '/providers/upstage.png',
    models: ['solar-pro', 'solar-mini'],
    unimplemented: [],
    thirdParty: [],
  },
  {
    name: 'Amazon Web Services',
    logoUrl: '/providers/amazon_bedrock.jpg',
    models: ['amazon.titan-text-premier-v1.0'],
    unimplemented: [],
    thirdParty: [
      'anthropic.claude-3-haiku-20240307-v1:0',
      'ai21.jamba-1-5-mini-v1:0',
      'us.meta.llama3-1-8b-instruct-v1:0',
    ],
  },
  {
    name: 'Meta',
    logoUrl: '/providers/meta_ai.png',
    models: [],
    unimplemented: ['LLAMA-2-13B'],
    thirdParty: [],
  },
  {
    name: 'Perplexity',
    logoUrl: '/providers/perplexity.png',
    models: ['sonar - pro'],
    unimplemented: ['llama-3.1-sonar-small-128k-online'],
    thirdParty: [],
  },
  {
    name: 'Reka',
    logoUrl: '/providers/reka.png',
    models: [],
    unimplemented: ['Reka Core'],
    thirdParty: [],
  },
  {
    name: 'xAI',
    logoUrl: '/providers/x.png',
    models: [],
    unimplemented: ['grok-2-1212'],
    thirdParty: [],
  },
];
